import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from "@/components/ui/select";
import { REFERRAL_SOURCES } from "@/lib/constants";
import { groupByCategory } from "@/lib/categories";

const Field = ({ id, label, error, children, className = "" }) => (
  <div className={className}>
    <Label htmlFor={id} className="text-xs font-semibold text-slate-600">{label}</Label>
    <div className="mt-1.5">{children}</div>
    {error && <p className="mt-1 text-xs text-rose-600" data-testid={`lead-form-error-${id}`}>{error}</p>}
  </div>
);

const inputCls = (err) => `h-11 rounded-xl ${err ? "border-rose-400 focus-visible:ring-rose-400" : ""}`;

const today = () => new Date().toISOString().slice(0, 10);

export const LeadFormFields = ({ values, errors, set, services, categories = [], mode }) => (
  <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
    <Field id="first_name" label="Nombre *" error={errors.first_name}>
      <Input id="first_name" value={values.first_name} onChange={(e) => set("first_name", e.target.value)} className={inputCls(errors.first_name)} data-testid="lead-form-first-name" />
    </Field>
    <Field id="last_name" label="Apellido">
      <Input id="last_name" value={values.last_name} onChange={(e) => set("last_name", e.target.value)} className={inputCls()} data-testid="lead-form-last-name" />
    </Field>
    <Field id="phone" label="Teléfono *" error={errors.phone}>
      <Input id="phone" type="tel" value={values.phone} onChange={(e) => set("phone", e.target.value)} className={inputCls(errors.phone)} data-testid="lead-form-phone" />
    </Field>
    <Field id="email" label="Correo *" error={errors.email}>
      <Input id="email" type="email" value={values.email} onChange={(e) => set("email", e.target.value)} className={inputCls(errors.email)} data-testid="lead-form-email" />
    </Field>
    <Field id="service_id" label="Servicio de interés">
      <Select value={values.service_id || undefined} onValueChange={(v) => set("service_id", v)}>
        <SelectTrigger className="h-11 rounded-xl" data-testid="lead-form-service-select"><SelectValue placeholder="Selecciona un servicio" /></SelectTrigger>
        <SelectContent>
          {categories.length ? groupByCategory(services, categories).map(({ category, services: list }) => (
            <SelectGroup key={category.id} data-testid={`lead-form-service-group-${category.slug || category.id}`}>
              <SelectLabel className="text-xs font-semibold uppercase tracking-wide text-[#1E6FD9]">{category.name}</SelectLabel>
              {list.map((s) => <SelectItem key={s.id} value={s.id} data-testid={`lead-form-service-option-${s.id}`}>{s.name}</SelectItem>)}
            </SelectGroup>
          )) : services.map((s) => <SelectItem key={s.id} value={s.id} data-testid={`lead-form-service-option-${s.id}`}>{s.name}</SelectItem>)}
        </SelectContent>
      </Select>
    </Field>
    <Field id="referral_source" label="¿Cómo nos conoció?">
      <Select value={values.referral_source || undefined} onValueChange={(v) => set("referral_source", v)}>
        <SelectTrigger className="h-11 rounded-xl" data-testid="lead-form-referral-select"><SelectValue placeholder="Selecciona una opción" /></SelectTrigger>
        <SelectContent>
          {REFERRAL_SOURCES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}
        </SelectContent>
      </Select>
    </Field>
    {mode === "agendar" && (
      <>
        <Field id="preferred_date" label="Fecha preferida *" error={errors.preferred_date}>
          <Input id="preferred_date" type="date" min={today()} value={values.preferred_date} onChange={(e) => set("preferred_date", e.target.value)}
                 className={inputCls(errors.preferred_date)} data-testid="lead-form-preferred-date" />
        </Field>
        <Field id="preferred_time" label="Hora preferida *" error={errors.preferred_time}>
          <Input id="preferred_time" type="time" value={values.preferred_time} onChange={(e) => set("preferred_time", e.target.value)}
                 className={inputCls(errors.preferred_time)} data-testid="lead-form-preferred-time" />
        </Field>
      </>
    )}
    <Field id="message" label="Mensaje" className="sm:col-span-2">
      <Textarea id="message" rows={3} value={values.message} onChange={(e) => set("message", e.target.value)} className="rounded-xl" data-testid="lead-form-message" />
    </Field>
  </div>
);
